import { Award, Users, Calendar, CheckCircle, Zap, Building2, BarChart3, Shield } from "lucide-react";
import aboutUsImage from "../assets/aboutUsPage.jpg";
import manDrowning from "../assets/manDrawing.jpg";
import Contact from "../components/Contact";
export default function AboutPage() {
  const teamMembers = [
    {
      name: "John Mitchell",
      role: "Основатель и генеральный директор",
      image:
        "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg?auto=compress&cs=tinysrgb&w=400",
    },
    {
      name: "Sarah Anderson",
      role: "Главный архитектор",
      image:
        "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=400",
    },
    {
      name: "Marcus Chen",
      role: "Руководитель проекта",
      image:
        "https://images.pexels.com/photos/1704488/pexels-photo-1704488.jpeg?auto=compress&cs=tinysrgb&w=400",
    },
    {
      name: "Emily Rodriguez",
      role: "Директор по дизайну",
      image:
        "https://images.pexels.com/photos/2774556/pexels-photo-2774556.jpeg?auto=compress&cs=tinysrgb&w=400",
    },
  ];
const stats = [
  { icon: Calendar, value: "15+", label: "Лет опыта" },
  { icon: Users, value: "500+", label: "Довольных клиентов" },
  { icon: Award, value: "50+", label: "Наград" },
];
  const values = [
    {
      icon: CheckCircle,
      title: "Профессионализм",
      description: "Наши специалисты - опытные профессионалы с высоким уровнем квалификации",
    },
    {
      icon: Users,
      title: "Индивидуальный подход",
      description: "Мы учитываем все потребности и пожелания клиента",
    },
    {
      icon: Award,
      title: "Инновации",
      description: "Используем современные методы и устойчивые практики",
    },
    {
      icon: Calendar,
      title: "Надёжность",
      description: "Сдаём проекты в срок и в рамках бюджета",
    },
  ];

  return (
    <div className="min-h-screen">
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">О Bart-Group</h1>
          <p className="text-2xl text-gray-300 max-w-2xl">
            Лидер отрасли: инновации, честность и высокое качество работ
          </p>
        </div>
      </section>

    <section className="relative overflow-hidden bg-[#fafaf9] py-20 sm:py-24 lg:py-32">
  {/* Background accents */}
 

  <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div className="grid items-center gap-14 lg:grid-cols-[0.95fr_1.05fr] lg:gap-20">
      {/* Image */}
      <div className="relative">
        <div className="relative overflow-hidden rounded-sm bg-slate-200 shadow-[0_30px_80px_rgba(15,23,42,0.18)]">
          <img
            src={aboutUsImage}
            alt="Наша команда на объекте"
            className="h-[440px] w-full object-cover sm:h-[520px] lg:h-[640px]"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/35 via-transparent to-transparent" />
        </div>

        {/* Floating badge */}
        <div className="absolute -bottom-6 left-4 max-w-[260px] rounded-sm bg-white p-5 shadow-2xl ring-1 ring-slate-200 sm:left-8">
          <div className="flex items-end gap-2">
            <span className="text-4xl font-bold tracking-[-0.05em] text-primaryBlue">
              100%
            </span>
            <span className="pb-1 text-sm font-semibold uppercase tracking-wide text-slate-400">
              клиентов
            </span>
          </div>

          <p className="mt-2 text-sm leading-6 text-slate-600">
            Удовлетворённость качеством выполненных работ
          </p>
        </div>

        {/* Small decorative card */}
        <div className="absolute right-4 top-4 hidden rounded-sm bg-white/90 px-4 py-3 shadow-lg backdrop-blur md:block">
          <p className="text-sm font-semibold text-slate-950">15+ лет опыта</p>
          <p className="text-xs text-slate-500">в строительстве и ремонте</p>
        </div>
      </div>

      {/* Content */}
      {/* Text Container */}
<div className="flex h-full max-w-[680px] flex-col justify-center lg:min-h-[620px]">
  {/* Eyebrow */}
  <div className="mb-12 flex items-center gap-5">
    <span className="h-px w-12 bg-[#147f8f]" />
    <span className="text-sm font-bold uppercase tracking-[0.45em] text-[#147f8f]">
      О БАРТ ГРУП
    </span>
  </div>

  {/* Heading */}
  <h2 className="max-w-[640px] text-4xl font-light leading-[1.12] tracking-[-0.045em] text-slate-500 md:text-5xl lg:text-[56px]">
    <span className="block font-semibold text-slate-950">
      Мы строим объекты,
    </span>
    <span className="block">которые служат</span>
    <span className="block">десятилетиями.</span>
  </h2>

  {/* Text */}
  <div className="mt-12 max-w-[620px] space-y-7 text-lg leading-[1.9] tracking-[0.01em] text-slate-600">
    <p>
      БАРТ ГРУП — строительная компания с более чем 15-летним опытом в
      проектировании, строительстве и ремонте объектов различной сложности.
    </p>

    <p>
      Мы объединяем профессиональную команду строителей, проектировщиков и
      инженеров, чтобы каждый этап — от идеи до сдачи объекта — был выполнен
      точно, качественно и в срок.
    </p>
  </div>

  {/* Divider */}
  <div className="my-9 h-px w-full bg-slate-200" />

  {/* Stats */}
  <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
    <div>
      <div className="flex items-end gap-2">
        <span className="text-4xl font-bold leading-none tracking-[-0.06em] text-slate-950">
          15
        </span>
        <span className="pb-1 text-lg font-bold text-[#147f8f]">+</span>
      </div>
      <p className="mt-5 text-base text-slate-500">Лет опыта</p>
    </div>

    <div>
      <div className="flex items-end gap-2">
        <span className="text-4xl font-bold leading-none tracking-[-0.06em] text-slate-950">
          120
        </span>
        <span className="pb-1 text-lg font-bold text-[#147f8f]">+</span>
      </div>
      <p className="mt-5 text-base text-slate-500">Довольных клиентов</p>
    </div>

    <div>
      <div className="flex items-end gap-2">
        <span className="text-4xl font-bold leading-none tracking-[-0.06em] text-slate-950">
          98
        </span>
        <span className="pb-1 text-lg font-bold text-[#147f8f]">%</span>
      </div>
      <p className="mt-5 text-base text-slate-500">Успешных проектов</p>
    </div>
  </div>

  {/* Divider */}
  <div className="my-9 h-px w-full bg-slate-200" />

  {/* Button */}

</div>
    </div>
  </div>
</section>

     <section className="bg-white py-20">
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
      {/* Left side — text */}
      <div>
        <div className="mb-8 flex items-center gap-4">
          <span className="h-px w-10 bg-primaryBlue" />
          <span className="text-sm font-bold uppercase tracking-[0.3em] text-primaryBlue">
            Почему выбирают нас
          </span>
        </div>

        <h2 className="mb-10 max-w-2xl text-4xl font-bold leading-tight tracking-[-0.03em] text-slate-900 md:text-5xl">
          Наши ключевые ценности
        </h2>

        <div className="space-y-0">
          {values.map((value, index) => {
            const Icon = value.icon;

            return (
              <div
                key={index}
                className="flex gap-6 border-b border-slate-200 py-8 last:border-b-0"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primaryBlue/10 text-primaryBlue">
                  <Icon className="h-5 w-5" />
                </div>

                <div>
                  <h3 className="mb-2 text-xl font-bold text-slate-900">
                    {value.title}
                  </h3>

                  <p className="max-w-xl text-base leading-relaxed text-slate-600">
                    {value.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Right side — image */}
      <div className="relative">
        <div className="aspect-[4/5] overflow-hidden rounded-sm">
          <img
            src={manDrowning}
            alt="Строительство и дизайн"
            className="h-full w-full object-cover"
          />
        </div>
      </div>
    </div>
  </div>
</section>

      {/* <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">
            Наша команда
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white p-6 rounded-sm shadow-lg hover:shadow-xl transition-all hover:-translate-y-2"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-56 object-cover rounded-lg mb-4"
                />
                <h3 className="text-xl font-bold text-slate-900">
                  {member.name}
                </h3>
                <p className="text-primaryBlue font-semibold mb-2">
                  {member.role}
                </p>
                <p className="text-gray-600 text-sm">
                  Опытный специалист с многолетним опытом в строительной
                  отрасли.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <section className="bg-[#fafaf9] py-24">
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    {/* Section Header */}
    <div className="mb-20">
      <div className="mb-10 flex items-center gap-4">
        <span className="h-px w-10 bg-[#147f8f]" />
        <span className="text-sm font-bold uppercase tracking-[0.35em] text-[#147f8f]">
          Наши преимущества
        </span>
      </div>

      <div className="grid items-end gap-10 lg:grid-cols-2">
        <h2 className="text-4xl leading-[1.08] tracking-[-0.04em] text-slate-950 md:text-5xl lg:text-6xl">
          <span className="block font-semibold">
            Надёжный подход
          </span>
          <span className="block font-light text-slate-500">
            к каждому проекту.
          </span>
        </h2>

        <p className="max-w-2xl text-lg leading-[1.8] text-slate-600 md:text-xl lg:pb-3">
          Мы проектируем и строим объекты с акцентом на долговечность,
          функциональность, энергоэффективность и удобство дальнейшей
          эксплуатации.
        </p>
      </div>
    </div>

    {/* Advantages Grid */}
    <div className="grid gap-px border border-slate-200 bg-slate-200 md:grid-cols-2 lg:grid-cols-3">
      {[
        {
          icon: Building2,
          title: "Современный и долговечный продукт",
          description:
            "Наша цель — разработка лучшего продукта на рынке строительства частных домов и коммерческого строительства.",
        },
        {
          icon: CheckCircle,
          title: "Полное сопровождение проекта",
          description:
            "Мы предоставляем полный комплекс услуг от проектирования объекта до благоустройства участка, на котором он возводится.",
        },
        {
          icon: BarChart3,
          title: "Функциональные планировки",
          description:
            "За счёт грамотного зонирования помещения получаем максимально полезный и функциональный итоговый проект.",
        },
        {
          icon: Shield,
          title: "Надежность всех конструкций",
          description:
            "Все несущие конструкции — фундамент, стены, перекрытия и кровля — надежно рассчитаны и прослужат минимум 50 лет.",
        },
        {
          icon: Award,
          title: "Проектировка инженерных сетей",
          description:
            "Мы качественно проектируем все инженерные сети, а также продумываем удобство их дальнейшей эксплуатации.",
        },
        {
          icon: Zap,
          title: "Энергоэффективность",
          description:
            "Благодаря оптимальной толщине стен и надежному утеплению сокращаем теплопотери, что позволяет экономить на отоплении.",
        },
      ].map((item, index) => {
        const Icon = item.icon;
        const number = String(index + 1).padStart(2, "0");

        return (
          <article
            key={index}
            className="group flex min-h-[360px] flex-col justify-between bg-white p-8 transition-colors duration-300 hover:bg-slate-50 lg:p-10"
          >
            <div>
              <div className="mb-12 flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center border border-slate-200 transition-colors duration-300 group-hover:border-[#147f8f]/40">
                  <Icon className="h-6 w-6 text-[#147f8f]" />
                </div>

                <span className="text-sm tracking-[0.25em] text-slate-400">
                  {number}
                </span>
              </div>

              <h3 className="mb-5 max-w-sm text-2xl font-semibold tracking-[-0.03em] text-slate-950">
                {item.title}
              </h3>

              <p className="max-w-sm leading-relaxed text-slate-600">
                {item.description}
              </p>
            </div>

            <div className="mt-10">
              <div className="mb-6 h-px w-full bg-slate-200" />

              <div className="flex items-center justify-between text-sm font-medium text-slate-500">
                <span>Преимущество</span>
                <span className="h-px w-8 bg-[#147f8f]/50" />
              </div>
            </div>
          </article>
        );
      })}
    </div>
  </div>
</section>
      {/* <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-primaryBlue mb-2">15+</div>
              <p className="text-xl text-gray-300">Лет опыта</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-primaryBlue mb-2">500+</div>
              <p className="text-xl text-gray-300">Выполненных проектов</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-primaryBlue mb-2">50+</div>
              <p className="text-xl text-gray-300">Полученных наград</p>
            </div>
            <div>
              <div className="text-5xl font-bold text-primaryBlue mb-2">100%</div>
              <p className="text-xl text-gray-300">Удовлетворённость клиентов</p>
            </div>
          </div>
        </div>
      </section> */}
      <Contact />
    </div>
  );
}
